import xhr from 'live/services/xhr'
import _ from 'lodash'

// refreshes value every 5 minutes
export const memoizedApi = _.mapValues(getApi(), v =>
    _.memoize(v, () => `${Math.floor(new Date().getTime() / (60 * 1000 * 5))}`)
)

export default {
    ...getApi(),
    memoized: memoizedApi
}

function getApi() {
    return {
        getAssets: () =>
            xhr
                .get('/services/plugin-liverig/assets/list')
                .then(response => response.data.filter(d => !!d.name)),
        getAutoAnalysisResults: params =>
            xhr.get(`/services/plugin-liverig-vis/auto-analysis/analyse?${params}`).then(response => response.data),
        saveAsAnnotation: params =>
            xhr
                .post(`/services/plugin-liverig-vis/auto-analysis/save-annotation`, params)
                .then(response => response.data),
        editAnnotation: params =>
            xhr
                .post(`/services/plugin-liverig-vis/auto-analysis/edit-annotation`, params)
                .then(response => response.data),
        deleteAnnotation: id =>
            fetch(`/services/plugin-annotations/annotations/${id}`, {
                method: 'delete',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' }
            })
    }
}
